
import {getLoginToken, getSelectedProject} from '../common/common.js'
import React, { Fragment, useState } from 'react';
import {
    ShowButton,
    SimpleShowLayout,
    List,
    Edit,
    Create,
    Datagrid,
    TextField,
    EditButton,
    ShowController,
    Show,
    ShowView,
    SelectInput,
    SimpleForm,
    TextInput,
    Filter,
    FormDataConsumer,
    ArrayInput,
    SimpleFormIterator,
    ImageField,
    ArrayField,
    BooleanField,
    BooleanInput,
    ImageInput,
    SelectArrayInput,
    NumberInput,
    NumberField,
    ReferenceInput,
    AutocompleteInput,
    AutocompleteArrayInput,
    useNotify,
    Toolbar,
    SaveButton,
    ReferenceField,
    FileInput,
    FileField,
    SingleFieldList,
    FunctionField,
    DateField,
    DateInput,
    useRecordContext,
    DateTimeInput,
    TopToolbar,
    Button as RaButton,
    useRefresh,
    ReferenceArrayField,
    ReferenceArrayInput,
    ChipField,
} from 'react-admin';

import {
    Divider, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, TextField as MuiTextField,
    Button, Box, CircularProgress, Avatar, CardContent, CardActions, CardHeader, Card, Grid
} from '@mui/material';
import { Link, useNavigate } from 'react-router-dom'

import client from '../common/client';

//Custom Import Start

//Custom Import End

const ReportFilter = props => (
    <Filter {...props}>

        {
            //Custom Filter Start

            //Custom Filter End
        }
    </Filter>
);

export const ReportList = props => {
    const navigate = useNavigate()
    const refresh = useRefresh();

    const handleSolve = (e, record) => {
        e.stopPropagation()
        if (window.confirm('Are you sure you want to solve this exception?')) {
            client.request_post('/api/report/solve',  record)
                .then(data => {
                    refresh()
                })
                .catch(err => {
                    alert(err)
                })
        }
    }
    //Custom List Code Start

    //Custom List Code End
    return (
        <List title="Report" {...props} filters={<ReportFilter />} mutationMode='optimistic'
            exporter={false}
            sort={{ field: 'reg_date', order: 'DESC' }}
            perPage={30}
        //Custom List Action Start

        //Custom List Action End
        >
            {
                //Custom List Body Start

                //Custom List Body End
            }
            <Datagrid bulkActionButtons={false}>
                <ReferenceField label="Project" source="project_id" reference="project">
                    <TextField source="name" />
                </ReferenceField>
                
                <TextField label="Screen" source="screen" />
                <TextField label="Exception" source="exception" />
                <TextField label="Count" source="count" />
                <DateField label="Recent Date" source="reg_date" locales={'ko'}/>
                <TextField label="Extra" source="extra" />
                <FunctionField label="Solve" render={record => (
                    <Button variant="outlined" 
                    onClick={(e)=>{
                        handleSolve(e, record)
                    }}>
                    Solve
                </Button>
                )}/>
                
            </Datagrid>
        </List>
    )
};
